<template>
    <div class="campaign">
        <base-form class="campaign__form">
            <base-card class="campaign__details">
                <template #card__title >
                    {{ $t('global.details') }}
                </template>
                <template #card__body >
                    <div class="campaign__body display--grid page--single__grid">
                        <base-field
                            class="campaign__body__name"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.name') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'name',
                                    name: 'name',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: model.name,
                                    browserAutocomplete: 'name',
                                    isRequired: $route.meta.isAdd,
                                    isMissing: errors.missing.name,
                                    errorOnSubmit: {
                                        show: errors.api.name ? true : false,
                                        messages: errors.api.name
                                    }
                                },
                                isEdition,
                                reset,
                                allowFilling: permissions.allowFilling
                            }"
                        />
                        <base-field
                            class="campaign__body__bdate"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.beginDate') },
                                input: {
                                    component: 'InputCalendar',
                                    name: 'beginDate',
                                    id: 'beginDate',
                                    targetClass: 'field__input--default typography--default color--default',
                                    value: model.beginDate,
                                    browserAutocomplete: 'off',
                                    isRequired: $route.meta.isAdd,
                                    isMissing: errors.missing.beginDate,
                                    errorOnSubmit: {
                                        show: errors.api.beginDate ? true : false,
                                        messages: errors.api.beginDate
                                    },
                                },
                                isEdition,
                                reset,
                                allowFilling: permissions.allowFilling
                            }"
                        />
                        <base-field
                            class="campaign__body__edate"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.endDate') },
                                input: {
                                    component: 'InputCalendar',
                                    name: 'endDate',
                                    id: 'endDate',
                                    targetClass: 'field__input--default typography--default color--default',
                                    value: model.endDate,
                                    dynamicData: {
                                        configs: {
                                            minDate: minDate,
                                        }
                                    },
                                    browserAutocomplete: 'off',
                                    isRequired: $route.meta.isAdd,
                                    isMissing: errors.missing.endDate,
                                    fileValidation: 'isAfterCertainDate',
                                    errors: [{
                                        type: 'isAfter', warning: $t('error.isAfter', { date: $t('global.beginDate') })
                                    }],
                                    errorOnSubmit: {
                                        show: errors.api.endDate ? true : false,
                                        messages: errors.api.endDate
                                    },
                                    validationParameter: payload.beginDate
                                },
                                isEdition,
                                reset,
                                allowFilling: permissions.allowFilling
                            }"
                        />
                        <base-field
                            class="campaign__body__type"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.type') },
                                input: {
                                    component: 'InputAutocomplete',
                                    id: 'typeId',
                                    name: 'typeId',
                                    type: 'text',
                                    value: `${types.api.id}`,
                                    targetClass: 'field__input--default typography--default color--default',
                                    isRequired: $route.meta.isAdd,
                                    isMissing: errors.missing.typeId,
                                    browserAutocomplete: 'off',
                                    dynamicData: {
                                        data: types.drop,
                                        apiValue: { value: `${types.api.id}`, label: types.api.name }
                                    },
                                    errorOnSubmit: {
                                        show: errors.api.typeId ? true : false,
                                        messages: errors.api.typeId
                                    }
                                },
                                reset,
                                allowFilling: permissions.allowFilling && !isEdition
                            }"
                        />
                        <base-field
                            class="campaign__body__workflow"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.workflow') },
                                input: {
                                    component: 'InputAutocomplete',
                                    id: 'workflowId',
                                    name: 'workflowId',
                                    type: 'text',
                                    value: `${workflows.api.id}`,
                                    targetClass: 'field__input--default typography--default color--default',
                                    isRequired: $route.meta.isAdd,
                                    isMissing: errors.missing.workflowId,
                                    browserAutocomplete: 'off',
                                    dynamicData: {
                                        data: workflows.drop,
                                        apiValue: { value: `${workflows.api.id}`, label: workflows.api.name }
                                    },
                                    errorOnSubmit: {
                                        show: errors.api.workflowId ? true : false,
                                        messages: errors.api.workflowId
                                    }
                                },
                                reset,
                                allowFilling: permissions.allowFilling && !isEdition
                            }"
                        />
                        <base-field
                            class="campaign__body__ddi"
                            :settings="{
                                label: { class: 'uppercase', text: $t('global.ddi') },
                                input: {
                                    component: 'InputAutocomplete',
                                    id: 'ddi',
                                    name: 'ddi',
                                    type: 'text',
                                    value: `${ddis.api.id}`,
                                    targetClass: 'field__input--default typography--default color--default',
                                    isRequired: $route.meta.isAdd,
                                    isMissing: errors.missing.ddi,
                                    browserAutocomplete: 'off',
                                    dynamicData: {
                                        data: ddis.drop,
                                        apiValue: { value: `${ddis.api.id}`, label: ddis.api.name },
                                        ordering: campaignHelpersLoading
                                    },
                                    errorOnSubmit: {
                                        show: errors.api.ddi ? true : false,
                                        messages: errors.api.ddi
                                    }
                                },
                                reset,
                                allowFilling: permissions.allowFilling
                            }"
                        />
                        <base-field
                            v-if="isEdition"
                            class="campaign__body__post-call-timer"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.automaticForward') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'postCallTimer',
                                    name: 'postCallTimer',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: `${postCallTimer || ''}`,
                                    browserAutocomplete: 'postCallTimer',
                                    placeholder: $t('placeholders.no'),
                                    isRequired: false,
                                    isMissing: errors.missing.postCallTimer,
                                    fileValidation: 'numberInt',
                                    errors: [{
                                        type: 'integer', warning: $t('error.integer')
                                    }],
                                    errorOnSubmit: {
                                        show: errors.api.postCallTimer ? true : false,
                                        messages: errors.api.postCallTimer
                                    }
                                },
                                isEdition,
                                reset,
                                allowFilling: permissions.allowFilling
                            }"
                        />
                        <base-field
                            class="campaign__body__state"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.state') },
                                input: {
                                    component: 'States',
                                    name: 'state',
                                    value: stateId,
                                    dynamicData: {
                                        states: [ 1, 2, 3 ]
                                    }
                                },
                                isEdition,
                                reset,
                                allowFilling: isEdition && permissions.allowFilling
                            }"
                        />
                    </div>
                </template>
            </base-card>
            <div class="campaign__cols display--grid page--single__half">
                <base-card v-if="isEdition" class="campaign__totals-by-typification">
                    <template #card__title >
                        {{ $t('reporting.totalsByTypification') }}
                    </template>
                    <template #card__body >
                        <div class="campaign__body">
                            <base-chart
                                :loading="charts.totalsByTypification.loading"
                                :chart="charts.totalsByTypification.data"
                            />
                        </div>
                    </template>
                </base-card>
                <base-card v-if="isEdition" class="campaign__final-typifications-by-hour">
                    <template #card__title >
                        {{ $t('reporting.finalTypificationsByHour') }}
                    </template>
                    <template #card__body >
                        <div class="campaign__body">
                            <base-chart
                                :loading="charts.finalTypificationsByHour.loading"
                                :chart="charts.finalTypificationsByHour.data"
                            />
                        </div>
                    </template>
                </base-card>
                <base-card class="campaign__associations">
                    <template #card__title >
                        {{ $t('global.associations') }}
                    </template>
                    <template #card__body >
                        <div class="campaign__body">
                            <base-field-with-url
                                class="campaign__body__client"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.client') },
                                    input: {
                                        ...( !isEdition && {
                                            component: 'InputAutocomplete',
                                            id: 'clientId',
                                            type: 'text',
                                            targetClass: 'field__input--default typography--default color--default',
                                            browserAutocomplete: 'off',
                                            isRequired: $route.meta.isAdd,
                                            isMissing: errors.missing.clientId,
                                            dynamicData: {
                                                data: [ ...clients ],
                                                ordering: order.loading
                                            },
                                            errorOnSubmit: {
                                                show: errors.api.clientId ? true : false,
                                                messages: errors.api.clientId
                                            }
                                        }),
                                        name: 'clientId',
                                        value: client.name
                                    },
                                    allowFilling: !isEdition && permissions.allowFilling
                                }"
                                :anchor="{
                                    url: `/clients/${clientId}`,
                                    disable: !clientId,
                                    see: $store.getters.can( 'clients', 'see' ),
                                    translationKey: 'viewProfile'
                                }"
                            />
                            <base-field
                                class="campaign__body__users"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.multiUsers') },
                                    input: {
                                        component: 'InputMultiOptions',
                                        name: 'users',
                                        id: 'users',
                                        targetClass: 'field__input--default typography--default color--default',
                                        value: helpers.selectedUsers || [],
                                        browserAutocomplete: 'off',
                                        placeholder: $t('placeholders.select'),
                                        isMissing: errors.missing.users,
                                        dynamicData: {
                                            data: [ ...( users || associateUsers ) ],
                                            ordering: order.loading,
                                            isEditPage: !$route.meta.isAdd
                                        },
                                        errorOnSubmit: {
                                            show: errors.api.users ? true : false,
                                            messages: errors.api.users
                                        },
                                        noListener: true
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: permissions.allowFilling
                                }"
                            />
                        </div>
                    </template>
                </base-card>
                <base-card v-if="isEdition" class="campaign__script" :add-margins="false">
                    <template #card__title >
                        <div class="card__header__title capitalize">{{ $t('global.scripts') }}</div>
                    </template>
                    <template #card__body >
                        <base-table
                            :headers="[
                                'name',
                                'state'
                            ]"
                            :list="model.scripts"
                            model="script"
                            :settings="{
                                component: 'RowScripts',
                                warning: $t('global.scripts')
                            }"
                            @open-modal="openModal"
                        />
                    </template>
                </base-card>

                <base-card v-if="isEdition" class="campaign__call-rules card--full-grid">
                    <template #card__title >
                        <div class="card__header__title capitalize">{{ $t('global.callRules') }}</div>
                    </template>
                    <template #card__body >
                        <base-table
                            :headers="[
                                'name',
                                'limitNumberOfAttempts',
                                'intervalOfAttempts',
                                'price',
                                'notify',
                                'sharingRules'
                            ]"
                            :list="model.contactCallStates.filter( state => state.visible )"
                            model="rules"
                            :settings="{
                                component: 'RowCallRules',
                                warning: $t('global.rules')
                            }"
                            @open-modal="openModalContactCallState"
                        />
                        <base-field
                            class="campaign__call-rules__emails"
                            :settings="{
                                label: {
                                    class: 'capitalize',
                                    text: $t('global.notificationEmails'),
                                },
                                input: {
                                    component: 'InputList',
                                    id: 'emails',
                                    name: 'emails',
                                    type: 'text',
                                    value: model.emails || '',
                                    browserAutocomplete: 'emails',
                                    placeholder: $t( 'placeholders.pressSpaceToAddToTheList' ),
                                    isRequired: $route.meta.isAdd,
                                    isMissing: errors.missing.emails,
                                    errorOnSubmit: {
                                        show: errors.api.emails ? true : false,
                                        messages: errors.api.emails,
                                    },
                                    list: helpers.selectedEmails || []
                                },
                                isEdition,
                                reset,
                                allowFilling: permissions.allowFilling && model.contactCallStates.some( state => state.notifiable === true )
                            }"
                        />
                    </template>
                </base-card>

                <base-card v-if="isEdition"
                    :class="[
                        'campaign__schedule'
                    ]"
                    :add-margins="false">
                    <template #card__title >
                        <div class="card__header__title capitalize">{{ $t('global.schedule') }}</div>
                    </template>
                    <template #card__body >
                        <schedule-table
                            :headers="[
                                'Segunda feira',
                                'Terça feira',
                                'Quarta feira',
                                'Quinta feira',
                                'Sexta feira',
                                'Sábado',
                                'Domingo'
                            ]"
                            :list="model.schedules"
                            model="schedule"
                            :addSchedule="addScheduleBool"
                            :startsAtProp="startsAtValue"
                            :endsAtProp="endsAtValue"
                            :settings="{
                                component: 'RowSchedules',
                                warning: $t('global.scripts')
                            }"
                            @open-modal="openModal"
                            @close-add-modal="trigerAddSchedule()"
                        />
                    </template>
                </base-card>
                <base-card v-if="isEdition" class="campaign__templates" :add-margins="false">
                    <template #card__title >
                        <div class="card__header__title capitalize">{{ $t('global.mailTemplates') }}</div>
                    </template>
                    <template #card__body >
                        <base-table
                            :headers="[
                                'name'
                            ]"
                            :list="model.mailingTemplates"
                            model="mailTemplates"
                            :settings="{
                                component: 'RowMailTemplates',
                                warning: $t('global.mailTemplates')
                            }"
                            @open-modal="openModal"
                        />
                    </template>
                </base-card>

                <base-card
                    :class="[
                        'campaign__observations',
                        `campaign__observations--${ isEdition ? 'full' : 'semi' }`
                    ]"
                >
                    <template #card__title >
                        {{ $t('global.observations') }}
                    </template>
                    <template #card__body >
                        <base-field
                            :class="[
                                'campaign__body__observations',
                                { 'background--grey--light': permissions.allowFilling }
                            ]"
                            :settings="{
                                label: { class: 'field__label--hide', text: $t('global.observations') },
                                input: {
                                    component: 'Textarea',
                                    name: 'observations',
                                    id: 'observations',
                                    class: 'campaign__body__observations__field typography--default color--default',
                                    value: model.observations || '',
                                    placeholder: $t('placeholders.observations'),
                                    disableClass: 'campaign__body__observations__field campaign__body__observations__field--disable display--block'
                                },
                                isEdition,
                                reset,
                                allowFilling: permissions.allowFilling
                            }"
                        />
                    </template>
                </base-card>
            </div>
        </base-form>
        <modal
            v-if="modal.show"
            :form="{
                class: 'modal__form--action display--flex',
                settings: {
                    typeOfPreparation: 'script',
                    ...( modal.active.button === 'delete' && { submissionType: 'processDelete' })
                }
            }"
            :customSettings="{
                color: modal.active.color,
                button: {
                    label: modal.active.button
                }
            }"
            :executeCloseAction="!modal.loading"
            @close="modal.show = false"
            :key="modal.show"
        >
            <template #modal__header >
                {{ $t(`global.${modal.active.translate}`) }}
            </template>
            <template #modal__body >
                {{ $t(`warning.${modal.active.translate}`) }}
            </template>
            <template #modal__info >
                <base-button
                    class="modal__content__button--negative background--transparent border--grey"
                    :class="{ 'disable': modal.loading }"
                    @click="modal.show = false"
                    v-html="$t('global.cancel')"
                />
            </template>
        </modal>
        <!-- modal de confirmação de apagar estado de chamada -->
        <modal
            v-if="modalContactCallState.show"
            :form="{
                class: 'modal__form--action display--flex'
            }"
            :customSettings="{
                color: modalContactCallState.active.color,
                button: {
                    label: modalContactCallState.active.button
                }
            }"
            :executeCloseAction="!modalContactCallState.loading"
            @close="modalContactCallState.show = false"
            :key="modalContactCallState.show"
        >
            <template #modal__header >
                {{ $t(`global.${modalContactCallState.active.translate}`) }}
            </template>
            <template #modal__body >
                {{ $t(`warning.${modalContactCallState.active.translate}`) }}
            </template>
            <template #modal__info >
                <base-button
                    class="modal__content__button--negative background--transparent border--grey"
                    :class="{ 'disable': modalContactCallState.loading }"
                    @click="modalContactCallState.show = false"
                    v-html="$t('global.cancel')"
                />
            </template>
        </modal>
        <modal
            v-show="importModal.show"
            :form="{
                class: 'import__modal',
                settings: {
                    typeOfPreparation: 'importContacts'
                }
            }"
            :customSettings="{
                color: 'green',
                class: 'import__modal__content',
                button: {
                    id: 'import-button',
                    label: 'importContacts'
                },
                show: {
                    infoSection: false,
                    actions: importModal.type === 'entities' || ( importModal.type === 'file' && payload.hasOwnProperty('resources') )
                }
            }"
            :executeCloseAction="!importModal.loading"
            :preventReset="true"
            @close="toggleImportContactsModal()"
            :key="importModal.show" >
            <template #modal__header >
                <h2 class="import__modal__header">{{ $t('global.importContacts') }}</h2>
            </template>
            <template #modal__body >
                <form
                    id="filterEntities"
                    class="import__filters position--relative display--flex"
                    @submit.prevent="filterEntities"
                    novalidate
                >
                    <div  v-if="!importModal.type || importModal.type === 'file'" class="import__modal__options">
                        <div class="import__modal__options__title">{{ $t('global.howDoYouWantToImportContacts') }}</div>
                        <div class="import__modal__options__content display--flex">
                            <base-card-option
                                :class="{ 'card--import-contacts__option--selected': payload.hasOwnProperty('resources') }"
                                :templates="{ have: true, list: [
                                    { endpoint:'/campaigns/import-contact-requests?format=csv', format: 'csv' },
                                    { endpoint:'/campaigns/import-contact-requests?format=xlsx', format: 'xlsx' },
                                ]}"
                            >
                                <template #card__icon >
                                    <base-field
                                        class="import__modal__options__resources"
                                        :settings="{
                                            label: { class: 'field__label--hide' },
                                            input: {
                                                component: 'InputFile',
                                                id: 'resources',
                                                name: 'resources',
                                                type: 'file',
                                                value: '',
                                                targetClass: 'field__input--default typography--default color--default',
                                                browserAutocomplete: 'off',
                                                formatsAllowed: [ '.csv', '.xlsx', '.xls' ]
                                            },
                                            isEdition: false,
                                            allowFilling: true
                                        }"
                                    />
                                </template>
                                <template #card__title >
                                    {{ $t(`global.importFile`) }} <span class="typography--light">(.csv, .xlsx)</span>
                                </template>
                            </base-card-option>
                            <base-card-option
                                class="pointer"
                                @click.native="importModal.type = 'entities'"
                            >
                                <template #card__icon >
                                    <icon-select-entities/>
                                </template>
                                <template #card__title >
                                    {{ $t(`global.selectEntities`) }} <span class="typography--light">(CAE)</span>
                                </template>
                            </base-card-option>
                        </div>
                    </div>

                    <template v-if="importModal.type === 'entities'">
                        <base-field
                            class="import__filters__aec"
                            v-model="eacArray"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.EAC') },
                                input: {
                                    component: 'InputMultiOptionsDrop',
                                    name: 'economicActivityCodes',
                                    id: 'economicActivityCodes',
                                    type: 'text',
                                    value: [],
                                    targetClass: 'import__filters__districts field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    placeholder: 'Ex: Arroz ou 01120',
                                    dynamicData: {
                                        data: economicActivityCodes,
                                    },
                                    noListener: true
                                },
                                allowFilling: true
                            }"
                        />
                        <base-field
                            class="import__filters__districts"
                            v-model="district"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.zone') },
                                input: {
                                    component: 'InputAutocomplete',
                                    name: 'districts',
                                    id: 'districts',
                                    type: 'text',
                                    value: district,
                                    targetClass: 'import__filters__districts field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    placeholder: 'Ex: Porto',
                                    dynamicData: {
                                        data: districts,
                                    },
                                    noListener: true
                                },
                                allowFilling: true
                            }"
                        />
                        <div class="display--flex import__filters__zipCode">
                            <base-field
                                class="import__filters__fromZipCode"
                                v-model="fromZipCode"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.zipCode') },
                                    input: {
                                        component: 'InputBasic',
                                        name: 'fromZipCode',
                                        id: 'fromZipCode',
                                        type: 'text',
                                        mask: '####-###',
                                        value: fromZipCode,
                                        class: 'import__filters__fromZipCode field__input--default typography--default color--default',
                                        browserAutocomplete: 'off',
                                        placeholder: '0000-000',
                                        noListener: true
                                    },
                                    allowFilling: true
                                }"
                            />
                            <span class="import__filters__zipCode--separator">-</span>
                            <base-field
                                class="import__filters__toZipCode"
                                v-model="toZipCode"
                                :settings="{
                                    label: { class: 'capitalize', text: '' },
                                    input: {
                                        component: 'InputBasic',
                                        name: 'toZipCode',
                                        id: 'toZipCode',
                                        type: 'text',
                                        mask: '####-###',
                                        value: toZipCode,
                                        class: 'import__filters__fromZipCode field__input--default typography--default color--default',
                                        browserAutocomplete: 'off',
                                        placeholder: '0000-000',
                                        noListener: true
                                    },
                                    allowFilling: true
                                }"
                            />
                        </div>
                        <base-button
                            form="filterEntities"
                            type="submit"
                            class="import__filters__button display--flex"
                            :hasHover="false"
                            :customClass="true"
                        >
                            <template #button__icon>
                                <icon-lup />
                            </template>
                        </base-button>
                    </template>
                </form>
                <base-table
                    v-if="importModal.type === 'entities'"
                    :headers="[
                        'id',
                        'name',
                        'EAC',
                        'zone',
                        'zipCode',
                        'contact'
                    ]"
                    :list="importModal.entities"
                    model="entity"
                    :settings="{
                        component: 'RowEntities',
                        warning: $t('global.entities')
                    }"
                    @open-modal="openModal"
                />
            </template>
        </modal>
        <modal
            v-if="callRuleModal.show"
            :form="{
                class: 'call-rule__modal',
                settings: {
                    id: 'callRuleModal',
                    typeOfPreparation: 'callRules'
                }
            }"
            :customSettings="{
                color: 'green',
                class: 'call-rule__modal__content',
                button: {
                    id: 'add-state-button',
                    label: 'addState'
                },
                show: {
                    infoSection: false
                }
            }"
            :executeCloseAction="!callRuleModal.loading"
            :preventReset="true"
            @close="toggleCallRuleModal()"
            :key="'callRuleModal'" >
            <template #modal__header >
                <h2 class="import__modal__header">{{ $t('global.addCallState') }}</h2>
            </template>
            <template #modal__body >
                <div class="call-rule__modal__fields display--grid">
                    <base-field
                        style="z-index: 4"
                        class="call-rule__modal__state"
                        :settings="{
                            label: { class: 'call__modal__label capitalize', text: $t('global.state') },
                            input: {
                                component: 'InputAutocomplete',
                                id: 'contactCallState',
                                name: 'contactCallState',
                                type: 'text',
                                value: '',
                                targetClass: 'field__input--default typography--default color--default',
                                browserAutocomplete: 'off',
                                isRequired: true,
                                isMissing: errors.missing.contactCallState,
                                dynamicData: {
                                    data: callRuleModal.states.drop,
                                    ordering: campaignHelpersLoading
                                },
                                noListener: true,
                                needsToMatchOption: false
                            },
                            allowFilling: permissions.allowFilling
                        }"
                    />
                    <base-field
                        v-if="canShowGroup"
                        class="call-rule__modal__group"
                        :settings="{
                            label: { class: 'call__modal__label capitalize', text: $t('global.group') },
                            input: {
                                component: 'InputAutocomplete',
                                id: 'group',
                                name: 'group',
                                type: 'text',
                                value: '',
                                targetClass: 'field__input--default typography--default color--default',
                                browserAutocomplete: 'off',
                                isRequired: true,
                                isMissing: errors.missing.group,
                                dynamicData: {
                                    data: [
                                        {
                                            value: 2,
                                            label: $t('callGroups.successfull'),
                                        }, {
                                            value: 3,
                                            label: $t('callGroups.unsuccessful'),
                                        }, {
                                            value: 4,
                                            label: $t('callGroups.rescheduling'),
                                        },
                                    ]
                                },
                                noListener: true
                            },
                            allowFilling: permissions.allowFilling
                        }"
                    />
                    <base-field
                        class="call-rule__modal__number-of-attempts"
                        :settings="{
                            label: { class: 'capitalize', text: $t('global.limitNumberOfAttempts') },
                            input: {
                                component: 'InputBasic',
                                id: 'numberOfAttempts',
                                name: 'numberOfAttempts',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: '',
                                browserAutocomplete: 'numberOfAttempts',
                                isRequired: false,
                                isMissing: errors.missing.numberOfAttempts,
                                fileValidation: 'numberInt',
                                errors: [{
                                    type: 'integer', warning: $t('error.integer')
                                }],
                                errorOnSubmit: {
                                    show: errors.api.numberOfAttempts ? true : false,
                                    messages: errors.api.numberOfAttempts
                                }
                            },
                            isEdition,
                            reset,
                            allowFilling: permissions.allowFilling
                        }"
                    />
                    <base-field
                        class="call-rule__modal__interval-of-attempts"
                        :settings="{
                            label: { class: 'capitalize', text: $t('global.intervalOfAttempts') },
                            input: {
                                component: 'InputBasic',
                                id: 'intervalOfAttempts',
                                name: 'intervalOfAttempts',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: '',
                                browserAutocomplete: 'intervalOfAttempts',
                                placeholder: $t( 'placeholders.intervalOfAttempts' ),
                                isRequired: permissions.allowFilling
                                    && payload.hasOwnProperty('numberOfAttempts')
                                    && parseInt( payload.numberOfAttempts ) > 1,
                                isMissing: errors.missing.intervalOfAttempts,
                                fileValidation: 'intervalOfAttempts',
                                errors: [{
                                    type: 'intervalOfAttempts', warning: $t('error.intervalOfAttempts')
                                }],
                                errorOnSubmit: {
                                    show: errors.api.intervalOfAttempts ? true : false,
                                    messages: errors.api.intervalOfAttempts
                                },
                                validationParameter: payload.numberOfAttempts
                            },
                            isEdition,
                            reset,
                            allowFilling: permissions.allowFilling
                                && payload.hasOwnProperty('numberOfAttempts')
                                && parseInt( payload.numberOfAttempts ) > 1
                        }"
                    />
                    <base-field
                        class="call-rule__modal__call-price"
                        :settings="{
                            label: { class: 'capitalize', text: $t('global.callPrice') },
                            input: {
                                component: 'InputBasic',
                                id: 'callPrice',
                                name: 'callPrice',
                                type: 'text',
                                class: 'field__input--default typography--default color--default',
                                value: '',
                                browserAutocomplete: 'callPrice',
                                placeholder: $t( 'placeholders.price' ),
                                isRequired: false,
                                isMissing: errors.missing.callPrice,
                                fileValidation: 'numberFloat',
                                errors: [{
                                    type: 'decimal', warning: $t('error.price')
                                }],
                                errorOnSubmit: {
                                    show: errors.api.callPrice ? true : false,
                                    messages: errors.api.callPrice
                                }
                            },
                            isEdition,
                            reset,
                            allowFilling: permissions.allowFilling
                        }"
                    />
                    <base-field
                        class="call-rule__modal__notify"
                        :settings="{
                            label: { class: 'capitalize', text: $t('global.notify') },
                            input: {
                                component: 'InputToggle',
                                name: 'notify',
                                id: 'notify',
                                value: 0
                            },
                            isEdition,
                            reset,
                            allowFilling: true
                        }"
                    />
                    <base-field
                        class="call-rule__modal__sharing-rules"
                        :settings="{
                            label: { class: 'capitalize', text: $t('global.sharingRules') },
                            input: {
                                component: 'InputToggle',
                                name: 'sharingRules',
                                id: 'sharingRules',
                                value: 0
                            },
                            isEdition,
                            reset,
                            allowFilling: true
                        }"
                    />
                </div>
            </template>
        </modal>
        <widget-options v-if="!$route.meta.isAdd">
            <widget-button
                v-if="$store.getters.can( 'campaign', 'importContacts' )"
                class="capitalize"
                :settings="{
                    action: () => toggleImportContactsModal(),
                    label: 'importContacts'
                }"
            />
            <widget-anchor
                v-if="$store.getters.can( 'campaign', 'addMailTemplate' )"
                :settings="{
                    url: `/campaigns/${model.id}/mail-templates/add`,
                    label: 'addMailTemplate'
                }"
            />
            <widget-button
                v-if="$store.getters.can( 'campaign', 'edit' )"
                class="capitalize"
                :settings="{
                    action: () => toggleCallRuleModal(),
                    label: 'addCallState'
                }"
            />
            <widget-anchor
                v-if="$store.getters.can( 'script', 'add' )"
                :settings="{
                    url: `/campaigns/${model.id}/scripts/add`,
                    label: 'addScript'
                }"
            />
            <widget-button
                 v-if="$store.getters.can( 'script', 'addSchedule' )"
                class="capitalize"
                :settings="{
                    action: () => trigerAddSchedule(),
                    label: 'addSchedule'
                }"
            />
        </widget-options>
    </div>
</template>

<script>
// helpers
import { sortObjectsArray } from '@/helpers/mixinGeneral';
import { get } from '@/helpers/requests';

// packages
import {
    reactive, toRefs, watch, computed
} from '@vue/composition-api';

// hooks
import { singleStructure, useData } from '@/hooks/use-data';
import { generateConfigsToUsersAndClients, useLists } from '@/hooks/get-lists';

// store
import { mapState, storePayload, useActions } from '@/hooks/use-store';

// utils
import { haveProperty } from '@/utils/';

// configs
import {
    campaignTypes, campaignWorkflows, districtsList,
    economicActivityCodesList
} from '@/configs/const';

// models
import { toggleRequiredFields } from '@/models/helpers/toggle-required-fields';

// mixins
import {
    addNewBarChart,
    addNewPieChart,
    finalTypificationsByHour,
    totalsByTypification
} from '@/helpers/mixinCharts';

export default {
    components: {
        ...singleStructure.components,
        BaseFieldWithUrl: () => import( /* webpackChunkName: 'BaseFieldWithUrl'  */ '@/components/bundles/fields/BaseFieldWithUrl' ),
        BaseTable: () => import( /* webpackChunkName: 'BaseTable' */ '@/components/bundles/tables/BaseTable' ),
        ScheduleTable: () => import( /* webpackChunkName: 'BaseTable' */ '@/components/bundles/tables/ScheduleTable' ),
        Modal: () => import( /* webpackChunkName: 'Modal' */ '@/components/bundles/layout/modals/Modal' ),
        BaseButton: () => import( /* webpackChunkName: 'BaseButton' */ '@/components/bundles/buttons/BaseButton' ),
        WidgetAnchor: () => import( /* webpackChunkName: 'WidgetAnchor' */ '@/components/bundles/layout/widget/options/types/WidgetAnchor' ),
        WidgetButton: () => import( /* webpackChunkName: 'WidgetButton' */ '@/components/bundles/layout/widget/options/types/WidgetButton' ),
        IconLup: () => import( /* webpackChunkName: 'IconLup' */ '@/components/bundles/layout/images/icons/IconLup' ),
        BaseCardOption: () => import( /* webpackChunkName: 'BaseCardOption' */ '@/components/bundles/cards/imports/contacts/BaseCardOption' ),
        /* eslint-disable max-len */
        IconSelectEntities: () => import( /* webpackChunkName: 'IconSelectEntities' */ '@/components/bundles/layout/images/icons/IconSelectEntities' ),
        BaseChart: () => import( /* webpackChunkName: 'BaseChart' */ '@/components/bundles/charts/BaseChart' )
    },
    props: {
        ...singleStructure.props
    },
    setup ( props, { root: { $route } }) {
        // obtenção das listagens
        const { users, clients, order } = useLists(
            generateConfigsToUsersAndClients( props.permissions.allowFilling, { props, route: $route, params: { users: { state: 'enabled' } } })
        );

        const state = reactive({
            client: {},
            clientId: '',
            associateUsers: [],
            stateId: 1,
            addScheduleBool: false,
            startsAtValue: '',
            endsAtValue: '',
            postCallTimer: '',
            types: {
                api: {},
                drop: Object.keys( campaignTypes ).map( key => ({ value: key, label: campaignTypes[key] }) )
            },
            workflows: {
                api: {},
                drop: Object.keys( campaignWorkflows ).map( key => ({ value: key, label: campaignWorkflows[key] }) )
            },
            ddis: {
                api: {},
                drop: []
            },
            usersTimerInterval: null,
            clientsTimerInterval: null,
            campaignHelpers: {},
            campaignHelpersLoading: false,
            charts: {
                totalsByTypification: { data: null, loading: false },
                finalTypificationsByHour: { data: null, loading: false }
            }
        });

        // ordenar drop de tipos
        sortObjectsArray( state.types.drop );

        // ordenar drop de users
        state.usersTimerInterval = setInterval( () => {
            if ( users?.value?.length ) {
                sortObjectsArray( users.value );
                clearInterval( state.usersTimerInterval );
            }
        }, 700 );

        // ordenar drop de clients
        state.clientsTimerInterval = setInterval( () => {
            if ( clients && clients.value.length ) {
                sortObjectsArray( clients.value );
                clearInterval( state.clientsTimerInterval );
            }
        }, 700 );

        const { actions } = useActions();

        const structureData = async newModel => {
            // se não exister novo model,
            // não é necessário executar o resto do código.
            if ( !Object.keys( newModel ).length )
                return;

            // obtenção dos dados do cliente associado
            // ao campanha.
            state.client = newModel?.client || {};
            state.client.id = state.client.id?.toString() ?? '';
            state.clientId = newModel?.client.id || '';

            actions( 'saveHelper', { selectedUsers: newModel.users.map( user => user.id ) });
            actions( 'saveHelper', { selectedEntities: [] });
            actions( 'saveHelper', { selectedEmails: newModel.mailingList });

            state.stateId = newModel.state.id;

            state.associateUsers = newModel.users.map( user => ({ value: user.id, label: user.name }) );

            state.types.api = { id: newModel.type.id, ...newModel.type };
            state.workflows.api = { id: newModel.workflow.id, ...newModel.workflow };
            actions( 'saveHelper', { workflow: state.workflows.api });

            const workflow = ( newModel.workflow?.name.toLowerCase() === 'outbound' ) ? 'outbound' : 'inbound';
            state.ddis.api = { id: newModel.ddis[workflow]?.id, name: newModel.ddis[workflow]?.value };

            state.postCallTimer = newModel?.settings?.postCallTimer;

            // Após obter dados da campanha, faz pedido dos dados de reporting
            // da campanha à API, se ainda não tiver sido feito o pedido.
            if ( newModel.name && !requestData?.reports ) {
                const chartNames = Object.keys( state.charts );

                // Inicialização dos loading de todos os charts da página.
                chartNames.forEach( chart => { state.charts[chart].loading = true; });

                requestData.reports = await get( `/reporting?campaignName=${newModel.name}` )
                    .then( ({ data }) => data.content.data.find( campaign => campaign.id === newModel.id ) );
            }
        };

        useData( props, structureData );

        // obtenção do payload & errors
        const store = reactive({
            payload: mapState({ module: 'storePayload', key: 'payload' }),
            helpers: mapState({ module: 'storePayload', key: 'helpers' }),
            blocks: mapState({ module: 'storePayload', key: 'blocks' })
        });

        watch( () => store.payload,
            newPayload => {
                if ( haveProperty( newPayload, 'clientId' ) )
                    state.clientId = newPayload.clientId;

                // Se o modal de importação de contactos estiver aberto e
                // se o tipo de importação for diferente de 'entities',
                // define o tipo de importação consoante exista ou não
                // 'resources' no payload
                if ( importModal.show ) {
                    if ( importModal.type !== 'entities' )
                        importModal.type = ( haveProperty( newPayload, 'resources' ) ) ? 'file' : null;
                }
            });

        const { errors, reset } = storePayload();

        // configs & handler da modal de
        // actualização da listagem de guiões.
        const modal = reactive({
            loading: mapState({ module: 'storePayload', key: 'loading' }),
            configs: {
                active: {
                    translate: 'activeScript',
                    color: 'green'
                },
                delete: {
                    translate: 'deleteScript',
                    color: 'red'
                }
            },
            active: {},
            show: false
        });

        // configs & handler da modal de
        // actualização da listagem de estados de chamada.
        const modalContactCallState = reactive({
            loading: mapState({ module: 'storePayload', key: 'loading' }),
            configs: {
                delete: {
                    translate: 'deleteCallState',
                    color: 'red'
                }
            },
            active: {},
            show: false
        });

        // Modal de importar contactos
        const importModal = reactive({
            loading: mapState({ module: 'storePayload', key: 'loading' }),
            configs: {
                active: {
                    translate: 'activeScript',
                    color: 'green'
                },
                delete: {
                    translate: 'deleteScript',
                    color: 'red'
                }
            },
            active: {},
            show: false,
            entities: [],
            type: null
        });

        // Modal de criar regra de chamada
        const callRuleModal = reactive({
            loading: mapState({ module: 'storePayload', key: 'loading' }),
            show: false,
            states: {
                drop: []
            }
        });

        /**
         * [method]
         * Obtem helpers relacionados com a
         * campanha e guarda-os nos helpers da store.
         * Coloca todos os valores dos ddis na drop correspondente.
         *
         * @param {String} endpoint
         * @since 1.2.3
         * @category Method
         * @autor Jorge Monteiro
         *
        */
        const getCampaignHelpers = async ({ endpoint }) => {
            state.campaignHelpersLoading = true;
            state.campaignHelpers = await get( endpoint ).then( ({ data }) => data.content.data );
            state.campaignHelpersLoading = false;
            state.ddis.drop = state.campaignHelpers.ddis.map( ddi => ({ value: ddi.id, label: ddi.value }) );
            actions( 'saveHelper', { contactCallStates: state.campaignHelpers.contactCallStates });
            callRuleModal.states.drop = state.campaignHelpers.contactCallStates.map(
                contactCallState => ({ value: contactCallState.name, label: contactCallState.description })
            );
        };

        // Obtém helpers da campanha
        if ( !Object.keys( state.campaignHelpers ).length )
            getCampaignHelpers({ endpoint: '/campaigns/helper' });

        /**
         * [method]
         * Abrir modal e definição
         * das definições do tipo de acção
         * que irão ser apresentadas na modal.
         * - cor
         * - título & texto
         * - button
         *
         * @param {String} actionType
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */
        const openModal = ({ actionType }) => {
            modal.active = {
                ...modal.configs[actionType],
                button: actionType
            };

            modal.show = true;
        };

        /**
         * [method]
         * Abrir modal e definição
         * das definições do tipo de acção
         * que irão ser apresentadas na modal.
         * - cor
         * - título & texto
         * - button
         *
         * @param {String} actionType
         * @since 1.2.8
         * @category Method
         * @autor Jorge Monteiro
         *
        */
        const openModalContactCallState = ({ actionType }) => {
            modalContactCallState.active = {
                ...modalContactCallState.configs[actionType],
                button: actionType
            };

            modalContactCallState.show = true;
        };

        /**
         * [method]
         * Manipular guião.
         * Conforma a acção executada pelo utilizador ( update ou delete )
         * vai actualizar a listagem de guiões.
         *
         * @param {Object} data
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */
        const handlerScript = {
            update: data => {
                props.model.scripts.forEach( script => {
                    if ( script.id === data.id )
                        script.enabled = true;
                    else if ( script.enabled )
                        script.enabled = false;
                });
            },
            delete: data => {
                props.model.scripts = props.model.scripts.filter( script => script.id !== data.id );
            }
        };

        // listener para quando existe
        // update de algum bloco do modelo.
        watch( () => store.blocks,
            newBlocks => {
                if ( Object.keys( newBlocks ).length ) {
                    if ( newBlocks.type === 'callRule' )
                        callRuleModal.show = false;
                    else {
                        handlerScript[newBlocks.script.type]( newBlocks.script.data );

                        modal.show = false;
                    }

                    // desbloqueia a barra de adição & edição.
                    actions( 'controlActionBar', { value: false });
                }
            });

        /**
         * [computed]
         * Validação da minima data para o campo
         * de *data fim*.
         *
         * @since 1.0.0
         * @category computed
         * @autor Tiago Martinho
         *
        */
        const minDate = computed( () => {
            const date = new Date( store.payload.beginDate || props.model.beginDate );
            return date.setDate( date.getDate() + 1 );
        });

        /**
         * [computed]
         * Verifica se se pode mostrar o campo do grupo
         * no modal de adicionar estado de chamada.
         *
         * @since 1.2.8
         * @category computed
         * @autor Jorge Monteiro
         *
        */
        const canShowGroup = computed( () => {
            const hasStateInPayload = haveProperty( store.payload, 'contactCallState' );
            const stateNames = props.model.contactCallStates.map( callState => callState.name );
            return hasStateInPayload && !stateNames.includes( store.payload.contactCallState );
        });

        const trigerAddSchedule = () => {
            state.addScheduleBool = !state.addScheduleBool;
            state.startsAtValue = '00:00:00';
            state.endsAtValue = '23:59:59';
        };

        /**
         * [method]
         * Toggle da modal proveninente do widget.
         *
         * @category Method
         *
        */
        const toggleImportContactsModal = () => {
            importModal.show = !importModal.show;
            importModal.type = null;

            // Caso acção seja abrir a modal é adicionado a informação ao payload.
            // Caso acção seja fechar a modal, é removido todo o payload da store.
            if ( importModal.show )
                actions( 'controlActionBar', { value: importModal.show });
            else {
                actions( 'resetState', false );
                actions( 'saveHelper', { selectedEntities: [] });
            }
        };

        /**
         * [method]
         * Toggle da modal de criação de regra de chamada.
         *
         * @category Method
         *
        */
        const toggleCallRuleModal = () => {
            callRuleModal.show = !callRuleModal.show;

            // Caso acção seja abrir a modal é adicionado a informação ao payload.
            // Caso acção seja fechar a modal, é removido todo o payload da store.
            if ( callRuleModal.show )
                actions( 'controlActionBar', { value: callRuleModal.show });
            else
                actions( 'resetState', false );
        };

        // configurações dos filtros de importação de contactos.
        const settings = reactive({
            district: '',
            eacArray: [],
            fromZipCode: '',
            toZipCode: ''
        });

        // lista de distritos
        const requestData = reactive({
            districts: Object.keys( districtsList ).map( key => ({ value: districtsList[key], label: districtsList[key] }) ),
            economicActivityCodes: Object.keys( economicActivityCodesList ).map( key => ({
                value: key,
                label: `${key} ${economicActivityCodesList[key]}`
            }) ),
            reports: null
        });

        const filterEntities = async () => {
            const payload = mapState({ module: 'storePayload', key: 'payload' });
            // validações para filtrar
            /* eslint-disable max-len */
            if ( ( payload.value.fromZipCode && payload.value.fromZipCode.length <= 4 ) || ( payload.value.toZipCode && payload.value.toZipCode.length <= 4 ) )
                return;

            const newParams = {
                ...( payload.value.districts && { districts: payload.value.districts }),
                ...( payload.value.fromZipCode && { fromZipCode: payload.value.fromZipCode }),
                ...( payload.value.toZipCode && { toZipCode: payload.value.toZipCode }),
                ...( payload.value.economicActivityCodes && { economicActivityCodes: [] })
            };

            if ( payload.value.economicActivityCodes ) {
                payload.value.economicActivityCodes.forEach( element => {
                    newParams.economicActivityCodes.push( element );
                });
            }

            importModal.entities = await get( '/contacts/entities', { ...newParams })
                .then( ({ data }) => data.content.data );
        };

        // close import contacts modal on submit
        watch( () => importModal.show,
            newShow => {
                if ( newShow ) {
                    const formInterval = setInterval( () => {
                        const formModal = document.getElementById( 'formModal' );
                        if ( formModal ) {
                            formModal.addEventListener( 'submit', () => {
                                const listener = setInterval( () => {
                                    const storeResponse = mapState({ module: 'storePayload', key: 'response' });
                                    if ( storeResponse.value.has && storeResponse.value.type === 'success' ) {
                                        importModal.show = false;
                                        clearInterval( listener );
                                    }
                                }, 500 );
                            });
                            clearInterval( formInterval );
                        }
                    }, 200 );
                }
            });

        // Se a opção de importação for através do formulário,
        // a key 'resources' é apagada do payload caso exista e
        // são atualizados os campos obrigatórios.
        watch( () => importModal.type,
            newType => {
                if ( newType === 'entities' ) {
                    actions( 'deleteField', { name: 'resources' });
                    toggleRequiredFields( 'importContacts', { field: 'entitiesIds', isRequired: true });
                    toggleRequiredFields( 'importContacts', { field: 'resources', isRequired: false });
                }
            });

        // O estado, nº limite de chamadas e intervalo de chamadas
        // passam a ser obrigatórios, consoante o modal de adicionar
        // estado de chamada esteja aberto ou fechado.
        watch( () => callRuleModal.show,
            newShow => {
                toggleRequiredFields( 'campaign', { field: 'contactCallState', isRequired: newShow, isRequiredOnEdit: newShow });
            });

        // Ao receber os dados do reporting, vai criar/ estruturar
        // os dados para poder mostrar nos gráficos.
        watch( () => requestData.reports,
            newReportingData => {
                // Adiciona gráfico que mostra os totais por tificação.
                state.charts.totalsByTypification.data = addNewPieChart({
                    statisticType: totalsByTypification,
                    updatedData: newReportingData.totalTipifications,
                    chartOptions: {
                        legendPosition: 'bottom',
                        legendHeight: 75,
                        legendHorizontalAlign: 'left'
                    }
                });
                state.charts.totalsByTypification.loading = false;

                // Adiciona gráfico que mostra as tipificações finais por hora.
                state.charts.finalTypificationsByHour.data = addNewBarChart({
                    statisticType: finalTypificationsByHour,
                    updatedData: newReportingData.contactCallsPerHour,
                    chartOptions: {
                        chartHeight: 'auto',
                        showYAxis: false,
                        showXAxisLabels: true,
                        barBorderRadius: 5
                    }
                });
                state.charts.finalTypificationsByHour.loading = false;
            });

        // obtenção do trigger
        const trigger = mapState({ module: 'storePayload', key: 'trigger' });

        // validação de quando o trigger é activo
        // de forma a fechar a modal.
        watch( () => trigger.value,
            newTrigger => {
                if ( newTrigger )
                    modalContactCallState.show = false;
            });

        return {
            ...toRefs( settings ),
            ...toRefs( state ),
            ...toRefs( store ),
            ...toRefs( requestData ),
            users,
            clients,
            order,
            errors,
            reset,
            modal,
            modalContactCallState,
            importModal,
            toggleImportContactsModal,
            callRuleModal,
            toggleCallRuleModal,
            openModal,
            openModalContactCallState,
            minDate,
            canShowGroup,
            sortObjectsArray,
            trigerAddSchedule,
            filterEntities
        };
    }
};
</script>

<style lang="scss">
    .campaign {
        &__cols {
            row-gap: 30px;
            margin-top: 30px;
        }
        &__body {
            row-gap: 40px;
            &__observations {
                @include rounded-corner( 19px );
                &__field {
                    height: 370px;
                    &--disable {
                        padding-top: 10px;
                    }
                }
            }
            &__url {
                @include typography-specs( 16px, 28px );
                margin-top: 35px;
            }
            &__client {
                margin-bottom: 40px;
            }
        }
        &__observations {
            &--full {
                grid-column: 1 / -1;
            }
        }
        &__call-rules {
            &__emails {
                margin-top: 60px;
            }
        }
        &__final-typifications-by-hour {
            &__title-x-axis {
                fill: red
            }
        }
    }
    .import {
        &__modal {
            &--transition {
                &-enter-active, &-leave-active {
                    height: 412px;
                    opacity: 1;
                    overflow: hidden;
                    @include transition( height .3s ease-in-out, opacity .2s ease-in-out );
                }
                &-enter, &-leave-to {
                    height: 0;
                    opacity: 0;
                    @include transition( height .3s ease-in-out .2s, opacity .3s ease-in-out );
                    will-change: height, opacity;
                }
            }
            &__header {
                @include typography-specs( 25px, 33px, 700 );
            }
            &__content {
                max-width: 1000px;
            }
            &__body {
                margin-top: 20px;
            }
            &__input {
                &--new-contact {
                    margin: 25px 0;
                }
            }
            &__icons {
                justify-content: center;
                margin-bottom: 45px;
                &__button {
                    @include transition( transfrom .3s ease-in-out );
                    will-change: transform;
                    &:active {
                        @include transform( scale( .8 ) );
                    }
                }
            }
            &__icon {
                @include transition( fill .3s ease-in-out );
                will-change: fill;
                &--reschedule {
                    margin: 0 20px;
                    &--active {
                        .circle {
                            fill: $color-green;
                        }
                        .path {
                            fill: $color-white;
                        }
                    }
                    .circle, .path {
                        @include transition( fill .3s ease-in-out );
                        will-change: fill;
                    }
                }
                &--green {
                    fill: rgba( $color-green, .6 );
                    &:hover {
                        fill: $color-green;
                        & .hand {
                            @include animation( thumbs-up .6s cubic-bezier( .73, .04, 1, .3 ) );
                        }
                    }
                    &--active {
                        fill: $color-green;
                    }
                }
                &--red {
                    fill: rgba( $color-red, .6 );
                    &:hover {
                        fill: $color-red;
                        & .hand {
                            @include animation( thumbs-down .6s cubic-bezier( .73, .04, 1, .3 ) );
                        }
                    }
                    &--active {
                        fill: $color-red;
                    }
                }
            }
            &__options {
                width: 100%;
                &__content {
                    gap: 32px;
                    flex-wrap: wrap;
                    justify-content: center;
                }
                &__title {
                    @include typography-specs( 25px, 29px, 700 );
                    width: 100%;
                    margin-bottom: 50px;
                    text-align: center;
                }
            }
        }
        &__filters{
            &__button {
                background: none;
                margin: 0 0 8px 8px;
                path{
                    fill: #707070;
                }
            }
            gap: 10px;
            align-items: end;
            &__districts,
            &__aec{
                flex: 2
            }
            &__zipCode{
                align-items: end;
                &--separator{
                    margin: 5px;
                }
            }
            &__fromZipCode, &__toZipCode {
                max-width: 130px;
                &__input {
                    @include elements-colors ( $bg-light, $color-white );
                    @include dimensions( 100%, 50px );
                    @include rounded-corner( 34px );
                    @include placeholder {
                        color: $color-white;
                        text-transform: capitalize;
                    }
                    caret-color: $color-white;
                    padding-right: 50px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                }
                .field__autocomplete {
                    &::after {
                        @include dimensions( 45px, 50px );
                        @include elements-colors ( $color-greenish, $color-white );
                        @include rounded-corner( 0 34px 34px 0 );
                    }
                    &--active{
                        .search__states__input, .search__campaigns__input {
                            color: $color-dark;
                            caret-color: $color-green;
                        }
                        &::after {
                            background: unset;
                        }
                    }
                    &__arrow {
                        path {
                            stroke: $color-white;
                        }
                        &--active {
                            path {
                                stroke: $color-green;
                            }
                        }
                    }
                }
            }
        }
    }
    .call-rule {
        &__modal {
            &--transition {
                &-enter-active, &-leave-active {
                    height: 412px;
                    opacity: 1;
                    overflow: hidden;
                    @include transition( height .3s ease-in-out, opacity .2s ease-in-out );
                }
                &-enter, &-leave-to {
                    height: 0;
                    opacity: 0;
                    @include transition( height .3s ease-in-out .2s, opacity .3s ease-in-out );
                    will-change: height, opacity;
                }
            }
            &__content {
                max-width: 550px;
            }
            &__fields {
                grid-template: auto / repeat( 2, 1fr );
                gap: 20px;
            }
            &__state, &__group {
                grid-column: 1 / 3;
            }
        }
    }
</style>